import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";

import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebase";

function Dashboard() {
  const [balance, setBalance] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalWithdraw, setTotalWithdraw] = useState(0);
  const [referralCommission, setReferralCommission] = useState(0);
  const [currentUserEmail, setCurrentUserEmail] = useState("");
  const isAdmin =
  currentUserEmail.toLowerCase() === "paylink450@gmail.com";
  const logoutUser = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error(error);
    alert("Logout failed.");
  }
};
  useEffect(() => {
    let unsubscribeUser = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUserEmail(user?.email || "");
      // Purana Firestore listener band karo
      if (unsubscribeUser) {
        unsubscribeUser();
        unsubscribeUser = null;
      }

      if (!user) {
        setBalance(0);
        setTotalDeposit(0);
        setTotalProfit(0);
        setTotalWithdraw(0);
        setReferralCommission(0);
        return;
      }

      const userRef = doc(db, "users", user.uid);

      unsubscribeUser = onSnapshot(
        userRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.data();

            setBalance(Number(userData.balance || 0));
            setTotalDeposit(Number(userData.totalDeposit || 0));
            setTotalProfit(Number(userData.totalProfit || 0));
            setTotalWithdraw(Number(userData.totalWithdraw || 0));
            setReferralCommission(
              Number(userData.referralCommission || 0)
            );
          } else {
            setBalance(0);
            setTotalDeposit(0);
            setTotalProfit(0);
            setTotalWithdraw(0);
            setReferralCommission(0);

            console.log("User document Firestore mein nahi mila.");
          }
        },
        (error) => {
          console.error("Dashboard data load error:", error);
        }
      );
    });

    return () => {
      unsubscribeAuth();

      if (unsubscribeUser) {
        unsubscribeUser();
      }
    };
  }, []);

  return (
    <div className="app">
      {/* Header */}
      <header className="header">
        <div>
          <h1 className="dashboard-logo-title">
            <img
              src="/snaptube-ghost.png"
              alt="SnapTube"
              className="header-logo"
            />

            <span>SnapTube</span>
          </h1>

          <p>Welcome Back</p>
        </div>

        <div className="header-actions">
         {isAdmin && (
  <Link to="/admin" className="admin-panel-button">
    ⚙ Admin
  </Link>
)}

          <Link to="/support" className="support-button">
            💬 Support
          </Link>
          <button
  type="button"
  onClick={logoutUser}
  className="support-button"
  style={{
    background: "#ff3b30",
    border: "none",
    cursor: "pointer",
  }}
>
  🚪 Logout
</button>
        </div>
      </header>

      {/* Balance Card */}
      <div className="balance-card">
        <p>Available Balance</p>

        <h2>${balance.toFixed(2)}</h2>
       <p
  style={{
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "-4px",
marginBottom: "12px",
    opacity: 0.95,
    textShadow: "0 0 8px rgba(255,255,255,0.5)",
  }}
>
  ≈ Rs {(balance * 280).toLocaleString()}
</p>

        <div className="balance-buttons">
          <Link to="/deposit" className="dashboard-link-button">
            Deposit
          </Link>

          <Link to="/withdraw" className="dashboard-link-button">
            Withdraw
          </Link>
        </div>
      </div>

      {/* Statistics */}
      <div className="stats">
        <div className="stat-box">
          <h3>${totalDeposit.toFixed(2)}</h3>
          <p>Total Deposit</p>
        </div>

        <div className="stat-box">
          <h3>${totalProfit.toFixed(2)}</h3>
          <p>Total Profit</p>
        </div>

        <div className="stat-box">
          <h3>${totalWithdraw.toFixed(2)}</h3>
          <p>Total Withdraw</p>
        </div>

        <div className="stat-box">
          <h3>${referralCommission.toFixed(2)}</h3>
          <p>Referral Commission</p>
        </div>
      </div>

      {/* Today's Earnings */}
      <div className="earnings-card">
        <h2>Total Earnings</h2>

        <div className="earning-row">
          <span>Machine Profit</span>
          <span>${totalProfit.toFixed(2)}</span>
        </div>

        <div className="earning-row">
          <span>Referral Bonus</span>
          <span>${referralCommission.toFixed(2)}</span>
        </div>

        <div className="earning-row total">
          <span>Total</span>

          <span>
            ${(totalProfit + referralCommission).toFixed(2)}
          </span>
        </div>
      </div>

      {/* Featured Machine */}
      <div className="machine-card">
        <div className="machine-image">🎬</div>

        <div className="machine-info">
          <h2>Premium Machine</h2>

          <p>
            Daily Profit: <strong>5%</strong>
          </p>

          <p>
            Price: <strong>$100</strong>
          </p>

          <p>
            Status: <strong>Lifetime Active</strong>
          </p>

          <Link to="/machine" className="machine-link-button">
            View Details →
          </Link>
        </div>
      </div>

      {/* Promotion */}
      <div className="promo-card">
        <h2>🔥 Special Promotion</h2>

        <p>
          Invite friends and earn up to
          <strong> 15% referral commission.</strong>
        </p>
      </div>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        <Link to="/dashboard" className="nav-item active">
          <span className="nav-icon">🏠</span>
          <span>Dashboard</span>
        </Link>

        <Link to="/deposit" className="nav-item">
          <span className="nav-icon">💰</span>
          <span>Deposit</span>
        </Link>

        <Link to="/machine" className="nav-item">
          <span className="nav-icon">▶️</span>
          <span>Machine</span>
        </Link>

        <Link to="/refer" className="nav-item">
          <span className="nav-icon">👥</span>
          <span>Referral</span>
        </Link>

        <Link to="/profile" className="nav-item">
          <span className="nav-icon">👤</span>
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
}

export default Dashboard;